import { Environment } from "@omni/types/enums/environment.enum";

import * as WindowManagement from "@/services/windowManagement";
import { WindowKeys } from "@/services/windowManagement";
import { Config } from "@/utils/config.utils";

export const getAssetLocation = () => {
    const assetsHost = SSR_PUBLIC_PATH;

    if (Config.general.environment === Environment.Local) {
        return assetsHost;
    }

    const version = WindowManagement.getObject(WindowKeys.VERSION);
    return `${assetsHost}/${version}`;
};
